import Get from "@/api/auth/Get";
import {isDefined} from "@/helper/Value";

const store = {
	namespaced: true,
	state: {
		loaded: false,
		application: undefined,
		customer: undefined,
		internal: undefined
	},
	mutations: {
		setLoaded: (state, value) => state.loaded = value,
		setApplication: (state, value) => state.application = value,
		setCustomer: (state, value) => state.customer = value,
		setInternal: (state, value) => state.internal = value,
	},
	actions: {
		async load ({commit})
		{
			const response = await new Get().call();

			commit('setApplication', response.data.application);
			commit('setCustomer', response.data.customer);
			commit('setInternal', response.data.internal);
			commit('setLoaded', true);
		},
		reloadIfCustomer ({state, dispatch})
		{
			if (state.customer)
			{
				dispatch('load');
			}
		}
	},
	getters: {
		isLoggedIn: (state) => isDefined(state.application) || isDefined(state.customer),
	}
};

export default store;
